 App.service('API',['$http','$location','$cookieStore',function ($http,$location,$cookieStore) {

    this.post = function (url,data) {
       // data.token = localStorage.getItem(accessTokenGlobal);
        return $http({
            method: "post",
            url:  url,
            data: data,
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            transformRequest: function (data) {
                return $.param(data);
            }
        }).then(function (result) {
            return result
        }, function (err) {
            
        })
    };

    this.post2 = function (url,data) {
       // data.token = localStorage.getItem(accessTokenGlobal);
        return $http({
            method: "post",
            url:  url,
            body: data,
            headers: {'Content-Type': 'application/json; charset=UTF-8'},
        }).then(function (result) {
            return result
        }, function (err) {

        })
    };

    this.get = function (url) {
        return $http.get(url)
            .then(function (result) {
                return result;
            }, function (err) {
                
            })
    };

    this.form = function (url, formData) {

    }
     this.seDefaultData = function () {

         var getAllValues = JSON.parse(sessionStorage.getItem("getDeafultValues"));
         console.log("default values",getAllValues);
         if(getAllValues)
         {
             var defaulValues = {};

             if($location.search().utm_source)
             {
                 defaulValues.old_source = getAllValues.new_source;
                 defaulValues.new_source = $location.search().utm_source;
             }
             else {
                 defaulValues.old_source = getAllValues.old_source;
                 defaulValues.new_source = getAllValues.new_source;
             }

             if($location.search().utm_medium)
             {
                 defaulValues.old_medium = getAllValues.new_medium;
                 defaulValues.new_medium = $location.search().utm_medium;
             }
             else {
                 defaulValues.old_medium = getAllValues.old_medium;
                 defaulValues.new_medium = getAllValues.new_medium;
             }

             if( $location.search().utm_campaign)
             {
                 defaulValues.old_campaign = getAllValues.new_campaign;
                 defaulValues.new_campaign = $location.search().utm_campaign;
             }
             else {
                 defaulValues.old_campaign = getAllValues.old_campaign;
                 defaulValues.new_campaign = getAllValues.new_campaign;
             }

             if($location.search().utm_term)
             {
                 defaulValues.term = $location.search().utm_term;
             }
             else {
                 defaulValues.term = getAllValues.term;
             }

             if($location.search().gclid)
             {
                 defaulValues.gclid = $location.search().gclid;
             }
             else {
                 defaulValues.gclid = getAllValues.gclid;
             }

             sessionStorage.setItem("getDeafultValues",JSON.stringify(defaulValues));
             $cookieStore.put("getDeafultValues",JSON.stringify(defaulValues))
             console.log("getvaluescookies",$cookieStore.get('getDeafultValues'), sessionStorage.setItem("getDeafultValues",JSON.stringify(defaulValues)))
         }
         else {

             defaulValues = {};
             defaulValues.old_source = 'Direct';
             defaulValues.new_source = $location.search().utm_source?$location.search().utm_source:'Direct';
             defaulValues.old_medium = 'Direct';
             defaulValues.new_medium = $location.search().utm_medium?$location.search().utm_medium:'Direct';
             defaulValues.old_campaign = 'NA';
             defaulValues.new_campaign = $location.search().utm_campaign?$location.search().utm_campaign:'Direct';
             defaulValues.term = $location.search().utm_term?$location.search().utm_term:'NA';
             defaulValues.gclid = $location.search().gclid?$location.search().gclid:'NA';
             sessionStorage.setItem("getDeafultValues",JSON.stringify(defaulValues));
             $cookieStore.put("getDeafultValues",JSON.stringify(defaulValues))
             console.log("getvaluescookies",$cookieStore.get('getDeafultValues'), sessionStorage.setItem("getDeafultValues",JSON.stringify(defaulValues)))
         }


     }

}]);